import script from "./jobtitlesList.vue?vue&type=script&lang=ts&setup=true"
export * from "./jobtitlesList.vue?vue&type=script&lang=ts&setup=true"

import "./jobtitlesList.vue?vue&type=style&index=0&id=24887600&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24887600"]])

export default __exports__